import { Theme, useMediaQuery } from "@mui/material";

export default function useIsMobileDrawer(): boolean {
  return useMediaQuery<Theme>((theme) => theme.breakpoints.down("md"));
}
